import { Notification } from "../../../entities/notification";
import NotificationRepository from "../../ports/notificationRepository";

export type fetchNotificationsUseCase = (
  where?: [
    string,
    "<" | "<=" | "==" | ">=" | ">" | "!=" | "in",
    string | number | boolean | null | Date | Array<any>
  ][],
  startAt?: any,
  limit?: number
) => Promise<{
  data?: Notification[];
  lastElement?: unknown;
  firstElement?: unknown;
}>;

export const buildFetchNotifications = (dependencies: {
  notificationRepo: NotificationRepository;
}): fetchNotificationsUseCase => {
  const { notificationRepo } = dependencies;

  const fetchNotifications = async (
    where?: [
      string,
      "<" | "<=" | "==" | ">=" | ">" | "!=" | "in",
      string | number | boolean | null | Date | Array<any>
    ][],
    startAt?: any,
    limit?: number
  ) => notificationRepo.fetchNotifications(where, startAt, limit);

  return fetchNotifications;
}